import 'arrayq';

import { PureConnect, React } from '../../react';
import { categoriesResource } from '../categories/resource';
import SortingMethod from '../filter/SortingMethod';

import { categoriesSelector, factiongroupsSelector, kindSelector, originSelector, participantgroupsSelector, participantsSelector, sortingSelector, statusSelector, visibleSelector } from './selectors';
import CATEGORIES from './actions/CATEGORIES';
import SORT from './actions/SORT';
import { selectors as metaSelectors } from '../../meta/selectors';
import cx from './admin-style.less';
import windowSelectors from '../../window/selectors';
import Origin from './Origin';
import ORIGINS from './actions/ORIGINS';
import { participantsResource } from '../../participant/resource';
import PARTICIPANTS from './actions/PARTICIPANTS';
import { usergroupResource } from '../../usergroup/resource';
import PARTICIPANTGROUPS from './actions/PARTICIPANTGROUPS';
import REMOVE_ALL from './actions/REMOVEALL';
import REMOVE_ALL_KINDS from './actions/REMOVE_ALL_KINDS';
import REMOVE_ALL_ORIGINS from './actions/REMOVE_ALL_ORIGINS';
import REMOVE_ALL_PARTICIPANTS from './actions/REMOVE_ALL_PARTICIPANTS';
import REMOVEALL_ALL_GROUPS from './actions/REMOVEALL_ALL_GROUPS';
import REMOVEALL_ALL_CATEGORIES from './actions/REMOVEALL_ALL_CATEGORIES';
import { Btn } from '../../react-toolbox-redesign/button';
import Status from './Status';
import STATUSES from './actions/STATUSES';
import { typeFactions } from '../question/authmodule/authcheck';
import { typeRoleAdmin, typeRoleClerk } from '../../admin/adminText';
import REMOVE_ALL_FACTIONS from './actions/REMOVE_ALL_FACTIONS';
import FACTIONGROUPS from './actions/FACTIONGROUPS';
import REMOVE_ALL_STATUSES_AND_FACTIONS from './actions/REMOVE_ALL_STATUSES_AND_FACTIONS';
import REMOVE_ALL_STATUSES from './actions/REMOVE_ALL_STATUSES';

export const AdminFilter = PureConnect('AdminFilter')(
    (state) => ({
        categories: categoriesSelector(state),
        categoriesSource: categoriesResource.selectors.items(state),
        participants: participantsSelector(state),
        participantSource: participantsResource.selectors.items(state),
        participantgroups: participantgroupsSelector(state),
        participantGroupSource: usergroupResource.selectors.items(state),
        originvalues: originSelector(state),
        docName: metaSelectors.docName(state),
        sorting: sortingSelector(state),
        visible: visibleSelector(state),
        screenSmall: windowSelectors.small(state),
    }),
    (dispatch) => ({
        removeAll: () => dispatch(REMOVE_ALL({})),
        removeAllKinds: () => dispatch(REMOVE_ALL_KINDS({})),   
        removeAllOrigins: () => dispatch(REMOVE_ALL_ORIGINS({})),   
        removeAllParticipants: () => dispatch(REMOVE_ALL_PARTICIPANTS({})),   
        removeAllGroups: () => dispatch(REMOVEALL_ALL_GROUPS({})),
        removeAllCategories: () => dispatch(REMOVEALL_ALL_CATEGORIES({})),
        updateCategories: (categories: number[]) => dispatch(CATEGORIES({ categories })),
        updateSorting: (sorting: SortingMethod) => dispatch(SORT({ sorting })),
        updateOrigins: (origins: Origin[]) => dispatch(ORIGINS({ origins })),
        updateParticipants: (participants: string[]) => dispatch(PARTICIPANTS({ participants })),
        updateParticipantgroups: (participantgroups: number[]) => dispatch(PARTICIPANTGROUPS({ participantgroups })),
    }),
    ({ categories, participants, participantgroups, originvalues, categoriesSource, participantSource, participantGroupSource, sorting, updateCategories, updateSorting, updateOrigins, updateParticipants, updateParticipantgroups, removeAll, removeAllKinds, removeAllOrigins, removeAllParticipants, removeAllGroups, removeAllCategories, screenSmall }) => {
        const participantsTotal = [
            ...participantSource,
        ];

        const participantGroupsTotal = [
            ...participantGroupSource.qWhere((itm) => 
                    itm.type!==typeFactions && 
                    itm.type!==typeRoleAdmin &&
                    itm.type!==typeRoleClerk &&
                    itm.type!==typeRoleAdmin),
        ];

        const categoriesTotal = [
            { id: 0, name: 'Geen categorie', color: '#efefef' },
            ...categoriesSource,
        ];

        const origins = [
            { id: 'mine', name: 'Mijzelf' },
            { id: 'others', name: 'Door anderen' },
        ];

        const onUpdateCategories = (value: number, checked: boolean) => {
            if (!checked) {
                if (categories) {
                    updateCategories([...categories, value]);
                } else
                    updateCategories([value]);
            } else {
                updateCategories(categories.qWhere((x) => x !== value));
            }
        };

        const onUpdateParticipants = (value: string, checked: boolean) => {
            if (!checked) {
                if (participants) {
                    updateParticipants([...participants, value]);
                } else
                    updateParticipants([value]);
            } else {
                updateParticipants(participants.qWhere((x) => x !== value));
            }
        };

        const onUpdateParticipantgroups = (value: number, checked: boolean) => {
            if (!checked) {
                if (participantgroups) {
                    updateParticipantgroups([...participantgroups, value]);
                } else
                    updateParticipantgroups([value]);
            } else {
                updateParticipantgroups(participantgroups.qWhere((x) => x !== value));
            }
        };

        const onUpdateOrigins = (value: Origin, checked: boolean) => {
            if (!checked) {
                if (originvalues)
                    updateOrigins([...originvalues, value]);
                else
                    updateOrigins([value]);
            } else {
                updateOrigins(originvalues.qWhere((x) => x !== value));
            }
        };

        const radioHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
            if (event.target.value === 'createdAsc')
                updateSorting('createdAsc');
            else if (event.target.value === 'createdDesc')
                updateSorting('createdDesc');
            else if (event.target.value === 'pageNumber')
                updateSorting('pageNumber');
        };

        const radioHandle = (value: string) => {
            if (value === 'createdAsc')
                updateSorting('createdAsc');
            else if (value === 'createdDesc')
                updateSorting('createdDesc');
            else if (value === 'pageNumber')
                updateSorting('pageNumber');  
        };      

        let nofiltersSelected = !(originvalues && originvalues.length) &&
                                !(participants && participants.length) &&
                                !(participantgroups && participantgroups.length) &&
                                !(categories && categories.length);

        return (
            <div className={cx('filter-container', screenSmall ? 'filter-container-small' : 'filter-container-big')}>
                <div className={cx('selected-items', nofiltersSelected ? 'wcag-invisible' : '')} >
                    <div className={cx('selected-items-header') }>
                        <h2>Filters</h2>
                        <span className={cx('selected-items_clear')} onClick={() => removeAll()}>Wis alle filters</span>
                    </div>
                    <div className={cx('selected-items-content')}>
                        
                        <div className={cx('origin-selections', originvalues && originvalues.length? 'icon_close': 'wcag-invisible')} onClick={() => removeAllOrigins()}><span>{'Aangemaakt door: '}</span>
                            {origins.qSelect((origin) => {
                                return ((originvalues ? originvalues.qIncludes(origin.id as Origin) : false) ?
                                    <div key={origin.id} className={'origin-class'}>{origin.name}</div> :
                                    null);
                            })}
                        </div>                       
                        <div className={cx('participant-selections', participants && participants.length? 'icon_close': 'wcag-invisible')} onClick={() => removeAllParticipants()}><span>{'Personen:'}</span>
                            {participantsTotal.qSelect((participant) => {
                                return ((participants ? participants.qIncludes(participant.id) : false) ?
                                    <div key={participant.id} className={'participant-class'}>{participant.name}</div> :
                                    null);
                            })}
                        </div>    
                        <div className={cx('participant-selections', participantgroups && participantgroups.length? 'icon_close': 'wcag-invisible')} onClick={() => removeAllGroups()}><span>{'Groepen:'}</span>
                            {participantGroupsTotal.qSelect((group) => {
                                return ((participantgroups ? participantgroups.qIncludes(group.id) : false) ?
                                    <div key={group.id} className={'group-class'}><span>{group.name}</span></div> :
                                    null);
                            })}
                        </div>  
                        <div className={cx('categories-selections', categories && categories.length? 'icon_close': 'wcag-invisible')} onClick={() => removeAllCategories()}><span>{'Categorien:'}</span>
                            {categoriesTotal.qSelect((category) => {
                                return ((categories ? categories.qIncludes(category.id) : false) ?
                                    <div key={category.id} className={'category-class'}>{category.name}</div> :
                                    null);
                            })}
                        </div>                              
                    </div>
                </div>
                <form>
                    <div className={cx('sort-filter')}>
                        <span className={cx('sorting-filter-label')}>Sorteren op</span>
                        <div className={cx('radio')} tabIndex={0} onKeyDown={() => radioHandle('createdAsc')}>
                            <input id="radio-1" name="Meest recent" type="radio"  value={'createdAsc'} checked={sorting === 'createdAsc'} onChange={radioHandler} />
                            <label htmlFor="radio-1" className={cx('radio-label')}><span>Meest recent</span></label>
                        </div>

                        <div className={cx('radio')} tabIndex={0} onKeyDown={() => radioHandle('pageNumber')}>
                            <input id="radio-2" name="Document volgorde" type="radio"  value={'pageNumber'} checked={sorting === 'pageNumber'} onChange={radioHandler}/>
                            <label  htmlFor="radio-2" className={cx('radio-label')}><span>Document volgorde</span></label>
                        </div>  
                    </div>                    
                    <div className={cx('origin-filter')}>
                        <span className={cx('origin-filter-label')}>
                            Aangemaakt door
                        </span>
                        {/* WCAG (checkbox):
                        1) input itself no tab (when styled with span/div) + type = checkbox
                        2) spacebar activates checkbox
                        3) div/span next to checkbox needs
                            * aria-checked when input checked
                            * aria-labelledby reference to text that explains checkbox
                            * role="checkbox" 
                        */}
                        {origins.qSelect((origin) =>
                            <div className={cx('default-checkbox-div', 'check-box-selection')}
                                key={origin.id}
                                tabIndex={-1}>
                                <input type="checkbox"
                                    className={cx('default-checkbox')}
                                    tabIndex={-1}
                                    checked={originvalues ? originvalues.qIncludes(origin.id as Origin) : false}
                                    onChange={onUpdateOrigins.bind(null, origin.id)}
                                    aria-hidden={true} />
                                <div role="checkbox"
                                    className={cx('checkmark')}
                                    aria-checked={originvalues ? (originvalues.qIncludes(origin.id as Origin) ? 'true' : 'false') : 'false'}
                                    aria-labelledby={'id-ref-' + origin && origin.id && origin.id.toString() ? origin.id.toString() : ''}
                                    tabIndex={0}
                                    onKeyPress={(ev: any) => {
                                        if (ev.key === 'Enter') {
                                            onUpdateOrigins(origin.id as Origin, originvalues ? originvalues.qIncludes(origin.id as Origin) : false);
                                        }
                                    }}
                                    onClick={() => {
                                        onUpdateOrigins(origin.id as Origin, originvalues ? originvalues.qIncludes(origin.id as Origin) : false);
                                    }}
                                >
                                </div>
                                <span id={`id-ref-` + origin && origin.id && origin.id.toString() ? origin.id.toString() : ''}>{origin.name}</span>
                            </div>,
                        )}
                    </div>
                    <div className={cx('personen-filter')}>
                        <span className={cx('personen-filter-label')}>
                            Gedeeld door
                        </span>
                        {/* WCAG (checkbox):
                        1) input itself no tab (when styled with span/div) + type = checkbox
                        2) spacebar activates checkbox
                        3) div/span next to checkbox needs
                            * aria-checked when input checked
                            * aria-labelledby reference to text that explains checkbox
                            * role="checkbox" 
                        */}
                        {participantsTotal ? participantsTotal.qWhere((prt)=> !!prt.id).qSelect((participant) =>
                            <div className={cx('default-checkbox-div', 'check-box-selection')}
                                key={participant.id}
                                tabIndex={-1}>
                                <input type="checkbox"
                                    className={cx('default-checkbox')}
                                    tabIndex={-1}
                                    checked={participants ? participants.qIncludes(participant.id) : false}
                                    onChange={onUpdateParticipants.bind(null, participant.id)}
                                    aria-hidden={true} />
                                <div role="checkbox"
                                    className={cx('checkmark')}
                                    aria-checked={participants ? (participants.qIncludes(participant.id) ? 'true' : 'false') : 'false'}
                                    aria-labelledby={'id-ref-' + participant && participant.id ? participant.id.toString() : ''}
                                    tabIndex={0}
                                    onKeyPress={(ev: any) => {
                                        if (ev.key === 'Enter') {
                                            onUpdateParticipants(participant.id, participants ? participants.qIncludes(participant.id) : false);
                                        }
                                    }}
                                    onClick={() => {
                                        onUpdateParticipants(participant.id, participants ? participants.qIncludes(participant.id) : false);
                                    }}
                                >
                                </div>
                                <span id={`id-ref-` + participant && participant.id ? participant.id.toString() : ''}>{participant.name}</span>
                            </div>,
                        ) : null}
                    </div>
                    <div className={cx('usergroup-filter')}>
                        <span className={cx('groepen-filter-label')}>
                            Groepen
                        </span>
                        {/* WCAG (checkbox):
                        1) input itself no tab (when styled with span/div) + type = checkbox
                        2) spacebar activates checkbox
                        3) div/span next to checkbox needs
                            * aria-checked when input checked
                            * aria-labelledby reference to text that explains checkbox
                            * role="checkbox" 
                        */}
                        {participantGroupsTotal ? participantGroupsTotal.qWhere((grp)=> !!grp.id).qSelect((group) =>
                            <div className={cx('default-checkbox-div', 'check-box-selection')}
                                key={group.id}
                                tabIndex={-1}>
                                <input type="checkbox"
                                    className={cx('default-checkbox')}
                                    tabIndex={-1}
                                    checked={participantgroups ? participantgroups.qIncludes(group.id) : false}
                                    onChange={onUpdateParticipantgroups.bind(null, group.id)}
                                    aria-hidden={true} />
                                <div role="checkbox"
                                    className={cx('checkmark')}
                                    aria-checked={participantgroups ? (participantgroups.qIncludes(group.id) ? 'true' : 'false') : 'false'}
                                    aria-labelledby={'id-ref-' + group && group.id ? group.id.toString() : ''}
                                    tabIndex={0}
                                    onKeyPress={(ev: any) => {
                                        if (ev.key === 'Enter') {
                                            onUpdateParticipantgroups(group.id, participantgroups ? participantgroups.qIncludes(group.id) : false);
                                        }
                                    }}
                                    onClick={() => {
                                        onUpdateParticipantgroups(group.id, participantgroups ? participantgroups.qIncludes(group.id) : false);
                                    }}
                                >
                                </div>
                                <span id={`id-ref-` + group && group.id ? group.id.toString() : ''}>{group.name}</span>
                            </div>,
                        ) : null}
                    </div>
                    <div className={cx('catgorie-filter')}>
                        <span className={cx('catgorie-filter-label')}>
                            Categorie
                        </span>
                        {/* WCAG (checkbox):
                        1) input itself no tab (when styled with span/div) + type = checkbox
                        2) spacebar activates checkbox
                        3) div/span next to checkbox needs
                            * aria-checked when input checked
                            * aria-labelledby reference to text that explains checkbox
                            * role="checkbox" 
                        */}
                        {categoriesTotal.qWhere((cat)=> !!cat.id).qSelect((category) =>
                            <div className={cx('default-checkbox-div', 'check-box-selection')}
                                key={category.id}
                                tabIndex={-1}>
                                <input type="checkbox"
                                    className={cx('default-checkbox')}
                                    tabIndex={-1}
                                    checked={categories.qIncludes(category.id)}
                                    onChange={onUpdateCategories.bind(null, category.id)}
                                    aria-hidden={true} />
                                <div role="checkbox"
                                    className={cx('checkmark')}
                                    aria-checked={categories.qIncludes(category.id) ? 'true' : 'false'}
                                    aria-labelledby={'id-ref-' + category && category.id && category.id.toString() ? category.id.toString() : ''}
                                    tabIndex={0}
                                    onKeyPress={(ev: any) => {
                                        if (ev.key === 'Enter') {
                                            onUpdateCategories(category.id, categories.qIncludes(category.id));
                                        }
                                    }}
                                    onClick={() => {
                                        onUpdateCategories(category.id, categories.qIncludes(category.id));
                                    }}
                                >
                                </div>
                                <span id={`id-ref-` + category && category.id && category.id.toString() ? category.id.toString() : ''}>{category.name}</span>
                            </div>,
                        )}
                    </div>
                </form>
            </div>
        );
    },
);

export const AdminFilterQuestions = PureConnect('AdminFilterQuestions')(
    (state) => ({
        categories: categoriesSelector(state),
        categoriesSource: categoriesResource.selectors.items(state),
        participants: participantsSelector(state),
        participantSource: participantsResource.selectors.items(state),
        factiongroups: factiongroupsSelector(state),
        participantGroupSource: usergroupResource.selectors.items(state),
        originvalues: originSelector(state),
        statusvalues: statusSelector(state),
        docName: metaSelectors.docName(state),
        sorting: sortingSelector(state),
        visible: visibleSelector(state),
        screenSmall: windowSelectors.small(state),
    }),
    (dispatch) => ({
        removeAllStatusesAndFactions: () => dispatch(REMOVE_ALL_STATUSES_AND_FACTIONS({})),
        updateStatus: (statuses: Status[]) => dispatch(STATUSES({ statuses })),
        removeAllFactions: () => dispatch(REMOVE_ALL_FACTIONS({})),
        removeAllStatuses: () => dispatch(REMOVE_ALL_STATUSES({})),
        updateFactiongroups: (factiongroups: number[]) => dispatch(FACTIONGROUPS({ factiongroups })),
    }),
    ({ statusvalues, updateStatus, screenSmall, participantGroupSource, factiongroups, updateFactiongroups, removeAllStatusesAndFactions, removeAllFactions, removeAllStatuses  }) => {
  
        const statuses = [
            { id: 1, name: 'Nieuw' },
            { id: 2, name: 'Behandelen' },
            { id: 3, name: 'In behandeling' },
            { id: 4, name: 'Klaar voor publiceren' },
            { id: 5, name: 'Gepubliceerd' },
            { id: 6, name: 'Gearchiveerd' },                        
        ];

        const factionGroupsTotal = [
            ...participantGroupSource.qWhere((itm) => itm.type===typeFactions),
        ];        

        const onUpdateStatus = (value: Status, checked: boolean) => {
            if (!checked) {
                if (statusvalues)
                    updateStatus([...statusvalues, value]);
                else
                    updateStatus([value]);
            } else {
                updateStatus(statusvalues.qWhere((x) => x !== value));
            }
        };

        const onUpdateFactiongroups = (value: number, checked: boolean) => {
            if (!checked) {
                if (factiongroups) {
                    updateFactiongroups([...factiongroups, value]);
                } else
                    updateFactiongroups([value]);
            } else {
                updateFactiongroups(factiongroups.qWhere((x: number) => x !== value));
            }
        };

        let nofiltersSelected = !(statusvalues && statusvalues.length) &&
                                    !(factiongroups && factiongroups.length);

        return (
            <div className={cx('filter-container', screenSmall ? 'filter-container-small' : 'filter-container-big')}>
                <form>
                    <div className={cx('selected-items', nofiltersSelected ? 'wcag-invisible' : '')} >
                        <div className={cx('selected-items-header') }>
                            <h2>Filters</h2>
                            <span className={cx('selected-items_clear')} onClick={() => removeAllStatusesAndFactions()}>Wis alle filters</span>
                        </div>
                        <div className={cx('selected-items-content')}>                   
                            <div className={cx('origin-selections', statusvalues && statusvalues.length? 'icon_close': 'wcag-invisible')} onClick={() => removeAllStatuses()}><span>{'Statussen:'}</span>
                                {statuses.qSelect((status) => {
                                    return ((statusvalues ? statusvalues.map((x)=>x.toString()).qIncludes(status.id.toString()) : false) ?
                                        <div key={status.id.toString()} className={'status-class'}>{status.name}</div> :
                                        null);
                                })}
                            </div>    
                            <div className={cx('participant-selections', factiongroups && factiongroups.length? 'icon_close': 'wcag-invisible')} onClick={() => removeAllFactions()}><span>{'Fracties:'}</span>
                                {factionGroupsTotal.qSelect((faction) => {
                                    return ((factiongroups ? factiongroups.qIncludes(faction.id) : false) ?
                                        <div key={faction.id} className={'group-class'}><span>{faction.name}</span></div> :
                                        null);
                                })}
                            </div>                            
                        </div>
                    </div>                    
                    <div className={cx('statuses-filter')}>
                        <span className={cx('statuses-filter-label')}>
                            Status
                        </span>
                        {/* WCAG (checkbox):
                        1) input itself no tab (when styled with span/div) + type = checkbox
                        2) spacebar activates checkbox
                        3) div/span next to checkbox needs
                            * aria-checked when input checked
                            * aria-labelledby reference to text that explains checkbox
                            * role="checkbox" 
                        */}
                        {statuses.qSelect((status) =>
                            <div className={cx('default-checkbox-div', 'check-box-selection', 'type', 'status'+ status.id.toString())}
                                key={status.id}
                                tabIndex={-1}            
                                >
                                <input type="checkbox"
                                    className={cx('default-checkbox')}
                                    tabIndex={-1}
                                    checked={statusvalues ? statusvalues.qIncludes(status.id as Status) : false}
                                    onChange={onUpdateStatus.bind(null, status.id)}
                                    aria-hidden={true} />
                                <div role="checkbox"
                                    className={cx('checkmark')}
                                    aria-checked={statusvalues ? (statusvalues.qIncludes(status.id as Status) ? 'true' : 'false') : 'false'}
                                    aria-labelledby={'id-ref-' + status && status.id && status.id.toString() ? status.id.toString() : ''}
                                    tabIndex={0}
                                    onKeyPress={(ev: any) => {
                                        if (ev.key === 'Enter') {
                                            onUpdateStatus(status.id as Status, statusvalues ? statusvalues.qIncludes(status.id as Status) : false);
                                        }
                                    }}
                                    onClick={() => {
                                        onUpdateStatus(status.id as Status, statusvalues ? statusvalues.qIncludes(status.id as Status) : false);
                                    }}
                                >
                                </div>
                                <span id={`id-ref-` + status && status.id && status.id.toString() ? status.id.toString() : ''}>{status.name}</span>
                            </div>,
                        )}
                    </div>
                    <div className={cx('usergroup-filter')}>
                        <span className={cx('groepen-filter-label')}>
                            Fractie
                        </span>
                        {/* WCAG (checkbox):
                        1) input itself no tab (when styled with span/div) + type = checkbox
                        2) spacebar activates checkbox
                        3) div/span next to checkbox needs
                            * aria-checked when input checked
                            * aria-labelledby reference to text that explains checkbox
                            * role="checkbox" 
                        */}
                        {factionGroupsTotal ? factionGroupsTotal.qWhere((grp)=> !!grp.id).qSelect((group) =>
                            <div className={cx('default-checkbox-div', 'check-box-selection')}
                                key={group.id}
                                tabIndex={-1}>
                                <input type="checkbox"
                                    className={cx('default-checkbox')}
                                    tabIndex={-1}
                                    checked={factiongroups ? factiongroups.qIncludes(group.id) : false}
                                    onChange={onUpdateFactiongroups.bind(null, group.id)}
                                    aria-hidden={true} />
                                <div role="checkbox"
                                    className={cx('checkmark')}
                                    aria-checked={factiongroups ? (factiongroups.qIncludes(group.id) ? 'true' : 'false') : 'false'}
                                    aria-labelledby={'id-ref-' + group && group.id ? group.id.toString() : ''}
                                    tabIndex={0}
                                    onKeyPress={(ev: any) => {
                                        if (ev.key === 'Enter') {
                                            onUpdateFactiongroups(group.id, factiongroups ? factiongroups.qIncludes(group.id) : false);
                                        }
                                    }}
                                    onClick={() => {
                                        onUpdateFactiongroups(group.id, factiongroups ? factiongroups.qIncludes(group.id) : false);
                                    }}
                                >
                                </div>
                                <span id={`id-ref-` + group && group.id ? group.id.toString() : ''}>{group.name}</span>
                            </div>,
                        ) : null}
                    </div>
                </form>
            </div>
        );
    },
);

export const AdminFilterRemoveAllFiltersButton = PureConnect('AdminFilterRemoveAllFiltersButton')(
    (state) => ({
        categories: categoriesSelector(state),
        participants: participantsSelector(state),
        participantgroups: participantgroupsSelector(state),
        kindsvalues: kindSelector(state),
        originvalues: originSelector(state),
    }),
    (dispatch) => ({
        removeAll: () => dispatch(REMOVE_ALL({})),
    }),
    ({ removeAll, kindsvalues, originvalues, participants, participantgroups, categories}) => {

        let nofiltersSelected = !(kindsvalues && kindsvalues.length) &&
                                !(originvalues && originvalues.length) &&
                                !(participants && participants.length) &&
                                !(participantgroups && participantgroups.length) &&
                                !(categories && categories.length);

        return (   
            !nofiltersSelected ?           
            <Btn type="button" 
                className={cx('btn', 'ghost-btn')} 
                aria-label={'Wissen van filters'}
                aria-haspopup={false}       
                tabIndex={0}
                disabled={false}         
                onClick={() => removeAll()}><span>Wis alle filters</span>
            </Btn> : null
        );
    },
);

export const AdminFilterJustSort = PureConnect('AdminFilterJustSort')(
    (state) => ({
        sorting: sortingSelector(state),
        visible: visibleSelector(state),
        screenSmall: windowSelectors.small(state),
    }),
    (dispatch) => ({
        updateSorting: (sorting: SortingMethod) => dispatch(SORT({ sorting })),
    }),
    ({  sorting, updateSorting, screenSmall }) => {

        const radioHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
            if (event.target.value === 'createdAsc')
                updateSorting('createdAsc');
            else if (event.target.value === 'createdDesc')
                updateSorting('createdDesc');
            else if (event.target.value === 'pageNumber')
                updateSorting('pageNumber');
        };

        const radioHandle = (value: string) => {
            if (value === 'createdAsc')
                updateSorting('createdAsc');
            else if (value === 'createdDesc')
                updateSorting('createdDesc');
            else if (value === 'pageNumber')
                updateSorting('pageNumber');
        };

        return (
            <div className={cx('filter-container', screenSmall ? 'filter-container-small' : 'filter-container-big')}>
                <form>
                    <div className={cx('sort-filter')}>
                        <span className={cx('sorting-filter-label')}>Sorteren op</span>
                        <div className={cx('radio')} tabIndex={0} onKeyDown={() => radioHandle('createdAsc')}>
                            <input id="radio-1" name="Meest recent" type="radio"  value={'createdAsc'} checked={sorting === 'createdAsc'} onChange={radioHandler} />
                            <label htmlFor="radio-1" className={cx('radio-label')}><span>Meest recent</span></label>
                        </div>

                        <div className={cx('radio')} tabIndex={0} onKeyDown={() => radioHandle('pageNumber')}>
                            <input id="radio-2" name="Document volgorde" type="radio"  value={'pageNumber'} checked={sorting === 'pageNumber'} onChange={radioHandler}/>
                            <label  htmlFor="radio-2" className={cx('radio-label')}><span>Document volgorde</span></label>
                        </div>  
                    </div>

                </form>
            </div>
        );
    },
);



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/filter/admin.tsx